import { DatePicker } from "@mui/x-date-pickers";
import { Dialog, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import React from "react";

const DomainDateSelectModal = (props) => {
	
	const handleFromDateChange = (fromDate) => {
		let toDate = props.toDate;
		if (fromDate > toDate) {
			toDate = fromDate;
		}
		props.onDateChanges(fromDate, toDate);
	};
	
	const handleToDateChange = (toDate) => {
		let fromDate = props.fromDate;
		if (toDate < fromDate) {
			toDate = fromDate;
		}
		props.onDateChanges(fromDate, toDate);
	};

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			sx={{ margin: "auto", overflow: "auto" }}
		>
			<DialogTitle id="alert-dialog-title">
				Select Date Range For Breaches
			</DialogTitle>
			<DialogContent sx={{ height: "100%", overflow: "auto" }}>
				<Stack sx={{ width: "100%", margin: "1em auto" }} direction="row" spacing={"1em"}>
					<DatePicker
						label="From Date"
						inputFormat="dd/MM/yyyy"
						value={props.fromDate}
						onChange={handleFromDateChange}
						renderInput={(params) => <TextField {...params} />}
					/>
					<DatePicker
						label="To Date"
						inputFormat="dd/MM/yyyy"
						value={props.toDate}
						onChange={handleToDateChange}
						renderInput={(params) => <TextField {...params} />}
					/>
				</Stack>
			</DialogContent>
		</Dialog>
	);

}

export default DomainDateSelectModal;